module.exports = __webpack_public_path__ + "img/plus.16380594.svg";